// Switches for features that aren't on for everyone yet.
// Create React App inlines REACT_APP_* variables when it builds, so a change needs a new build.

import { operatorName } from './operator';

// Whether the operator's handle is in a pipe-separated list of handles, e.g. "askitalian|pizzaplace"
export const operatorIsListed = (list: string | undefined, handle: string) =>
    (list ?? '')
        .split('|')
        .map((item) => item.trim().toLowerCase())
        .filter(Boolean)
        .includes(handle.trim().toLowerCase());

// Choose where to order from in a modal over the first site's menu, in place of the landing page
export const siteSelectModal = operatorIsListed(process.env.REACT_APP_SITE_SELECT_MODAL, operatorName);

// Like the above, but for half of the visitors to the operator, chosen at random for each (and kept for them), so the two can be compared
export const siteSelectModalSplit = operatorIsListed(process.env.REACT_APP_SITE_SELECT_MODAL_SPLIT, operatorName);
